import React,{Component} from 'react';
import './App.css';
import {BrowserRouter,Route,Switch,Link} from 'react-router-dom'
import { Layout } from 'antd';
import Slider from './Component/Slider'

import Booking  from './Component/Booking'
import Test  from './Component/Test/Test'
import Report  from './Component/Report/Report'
import Categories  from './Component/Categories/Categories'

import Add from './Component/Test/Add'
import Package from './Component/Package/Package';
import Query from './Component/Query';
import Prescription from './Component/Prescription';
import Filter from './Component/Filter';

const { Header, Content, Footer} = Layout;





export default class App extends Component{
  render(){
    return(
      <BrowserRouter>
          <Layout style={{ minHeight: '100vh' }}>
            <Slider />
            <Layout className="site-layout">
              <Header className="site-layout-background" style={{ padding: 0 }} />
              <Content style={{ margin: '0 16px' }}>
                <Switch>
                  <Route path="/test" component={Test} />
                  <Route path="/categories/" component={Categories}/>
                  <Route path="/report" component={Report} />
                  <Route path="/booking" component={Booking} />
                  <Route path="/queries" component={Query} />
                  <Route path="/prescription" component={Prescription} />
                  <Route path="/updateData" component={Filter} />
                  <Route path="/package" component={Package} />
                
                </Switch>


               </Content>
              <Footer style={{ textAlign: 'center' }}>Ant Design ©2018 Created by Ant UED</Footer>
            </Layout>
          </Layout>
      </BrowserRouter>
    )
  }
}